import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Checkbox, FormGroup, FormControlLabel } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import httpClient from "../services.httpClient";
import { useQueryClient } from "react-query";

function CreateUser({ open, setIsOpen, playlists, currentUser }) {
  const [submissionError, setSubmissionError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [spotifyIds, setSpotifyIds] = useState([]);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (open) {
      setEmail(currentUser?.email || "");
      setPassword(currentUser?.password || "");
      setSpotifyIds(currentUser?.spotifyIds || []);
      setSubmissionError("");
    }
  }, [open, currentUser]);

  const handleAddUser = () => {
    if (!email || !password) {
      setSubmissionError("Please enter email and password");
      return;
    }
    if (currentUser) {
      httpClient
        .put(`/users/${currentUser._id}`, {
          email,
          password,
          spotifyIds,
        })
        .then(() => {
          toast.success("User updated successfully");
          queryClient.invalidateQueries({ queryKey: ["users"] });
          setIsOpen(false);
        })
        .catch((err) => {
          if (err.response.data) setSubmissionError(err.response.data.message);
        });
    } else {
      httpClient
        .post(`/users`, {
          email,
          password,
          spotifyIds,
        })
        .then(() => {
          toast.success("User created successfully");
          queryClient.invalidateQueries({ queryKey: ["users"] });
          setIsOpen(false);
        })
        .catch((err) => {
          if (err.response.data) setSubmissionError(err.response.data.message);
        });
    }
  };

  return (
    <div>
      <Dialog keepMounted open={open}>
        <DialogTitle id="form-dialog-title">
          {currentUser ? "Update User" : "Create New User"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>User details</DialogContentText>
          {submissionError && <Alert severity="error">{submissionError}</Alert>}

          <TextField
            autoFocus
            margin="dense"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            id="name"
            label="Email"
            type="text"
            fullWidth
          />
          <TextField
            autoFocus
            margin="dense"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            id="name"
            label="Password"
            type="text"
            fullWidth
          />
          <FormGroup>
            {playlists?.map((playlist) => (
              <FormControlLabel
                key={playlist._id}
                control={
                  <Checkbox
                    checked={spotifyIds.includes(playlist.spotifyId)}
                    onChange={(e) => {
                      setSpotifyIds((prev) => {
                        if (e.target.checked) {
                          return [...prev, playlist.spotifyId];
                        } else {
                          return prev.filter((id) => id !== playlist._id);
                        }
                      });
                    }}
                  />
                }
                label={playlist.name}
              />
            ))}
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAddUser} color="primary">
            {currentUser ? "Update User" : "Create User"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CreateUser;
